import { FormControlLabel, RadioGroup } from "@mui/material";
import { useTranslation } from "react-i18next";
import { PlanRadio, RadioCheckedIcon, RadioIcon } from "../RadioStyles";
import styles from "./styles.module.scss";

export type PurchaseMode = "on-file" | "new";

type PaymentModeSelectorProps = {
  selectedMode: PurchaseMode | null;
  onSelect: (value: PurchaseMode) => void;
  purchasing: boolean;
};

export default function PaymentModeSelector(props: PaymentModeSelectorProps) {
  const { t } = useTranslation();

  return (
    <RadioGroup
      className={styles.modeSelector}
      row
      defaultValue="on-file"
      value={props.selectedMode}
      onChange={e => props.onSelect(e.target.value === "on-file" ? "on-file" : "new")}
    >
      <FormControlLabel
        disabled={props.purchasing}
        value="on-file"
        control={
          <PlanRadio
            disableRipple
            color="default"
            checkedIcon={<RadioCheckedIcon />}
            icon={<RadioIcon />}
          />
        }
        label={
          <span className={styles.paymentType}>{t("Common.checkout.paymentOnFile")}</span>
        }
      />
      <FormControlLabel
        value="new"
        control={
          <PlanRadio
            disableRipple
            color="default"
            checkedIcon={<RadioCheckedIcon />}
            icon={<RadioIcon />}
          />
        }
        label={
          <span className={styles.paymentType}>
            {t("Common.checkout.addPaymentMethod")}
          </span>
        }
      />
    </RadioGroup>
  );
}
